import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.08464 4.31333V17.6467H15.9186V8.20018L12.0317 4.31333H5.08464ZM3.8451 3.0738C4.1186 2.80031 4.48953 2.64667 4.8763 2.64667H12.3769C12.5979 2.64667 12.8099 2.73446 12.9662 2.89075L17.3412 7.26575C17.4974 7.42203 17.5852 7.63399 17.5852 7.855V17.855C17.5852 18.0465 17.5475 18.2361 17.4742 18.4131C17.401 18.59 17.2935 18.7508 17.1581 18.8862C17.0227 19.0216 16.8619 19.129 16.685 19.2023C16.5081 19.2756 16.3184 19.3133 16.1269 19.3133H4.8763C4.48953 19.3133 4.1186 19.1597 3.8451 18.8862C3.57161 18.6127 3.41797 18.2418 3.41797 17.855V4.105C3.41797 3.71823 3.57161 3.34729 3.8451 3.0738Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3763 2.64667C12.8365 2.64667 13.2096 3.01976 13.2096 3.48V7.02167H16.7519C17.2122 7.02167 17.5853 7.39476 17.5853 7.855C17.5853 8.31524 17.2122 8.68833 16.7519 8.68833H12.3763C11.9161 8.68833 11.543 8.31524 11.543 7.855V3.48C11.543 3.01976 11.9161 2.64667 12.3763 2.64667Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.72455 12.5782C8.04998 12.2528 8.57762 12.2528 8.90306 12.5782L10.5013 14.1765L12.0995 12.5782C12.425 12.2528 12.9526 12.2528 13.2781 12.5782C13.6035 12.9037 13.6035 13.4313 13.2781 13.7568L11.0906 15.9443C10.7651 16.2697 10.2375 16.2697 9.91205 15.9443L7.72455 13.7568C7.39911 13.4313 7.39911 12.9037 7.72455 12.5782Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.5013 9.52167C10.9615 9.52167 11.3346 9.89476 11.3346 10.355V15.355C11.3346 15.8152 10.9615 16.1883 10.5013 16.1883C10.0411 16.1883 9.66797 15.8152 9.66797 15.355V10.355C9.66797 9.89476 10.0411 9.52167 10.5013 9.52167Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }